var bankAccount = require('./lib/bank-account');
var email = require('./lib/email');
var phone = require('./lib/phone');
var nationalId = require('./lib/national-id');
module.exports = {
  bankAccount: bankAccount,
  email: email,
  phone: phone,
  nationalId: nationalId
};